import { urlApi } from "../../utils/strings"

export interface ProductoImagesI {
    imgBackground?: File
    productos_imagenes?: File[]
    productos_imagenes_pequenas?: File[]
    imagen_principal?: File
    infografia?: File
}

/*const handleUploadImages = async (
    data: any, {imgBackground, productos_imagenes, productos_imagenes_pequenas}: ProductoImagesI, id:string
) => {
  const url = urlApi(`/multiple_images.php`)

    if (true) {
      const formData = new FormData();
      
      if(imgBackground){
        formData.append('image', imgBackground);
        formData.append('path', "Productos"); 
      }

      if(productos_imagenes){
        for(let imagen of productos_imagenes){
            const formData = new FormData();
            formData.append('image', imagen);
            formData.append('path', "Productos");
        }
      }
  
      if(productos_imagenes_pequenas){
          for(let imagen of productos_imagenes_pequenas){
              const formData = new FormData();
              formData.append('image', imagen);
              formData.append('path', "Productos");
          }
      }
        
      try {
          const response = await fetch(url, {
            method: 'POST',
            body: formData,
          });
    
          const {uploaded_files} = await response.json();
      
          const rute = `${"Productos"}/${id}/${uploaded_files.filename}`

          data.img_background = rute
          data.path_img_background = rute
          data.imagenes = uploaded_files.imagenes

          if (response.ok) {
            //alert('Imagen subida con éxito');
            console.log(uploaded_files);
          } else {
            //alert('Error al subir la imagen');
            console.error(uploaded_files);
          }
        } catch (error) {
          console.error('Error:', error);
          alert('Error al subir la imagen');
        }
    }


    return data

}*/

export const addProducto = async (data: FormData, images: ProductoImagesI) => {
  const url = urlApi(`/productos/guardar_producto.php`)

  const response = await fetch(url, {
      method: 'POST',
      body: data,
    });

  if (!response.ok) {
    throw new Error('Error al guardar el producto');
  }

  //return await response.json();
}

export const updateProducto = async (id: string, data: any, images?: ProductoImagesI, merge = true) => {



  const url = urlApi(`/productos/guardar_producto.php`)

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body:  (data),
  });



}

/*no se usa
export const deleteProducto = async (id: string) => {

    return  null
    return await updateDoc(doc(db, FS_FIELDS.PRODUCTOS, id), {
        activo: false
    })

}*/

export const getProducto = async (id: string) => {

    const response = await fetch(urlApi(`/productos/obtener_producto.php?id=${id}`)); 
         
    const { data } = await response.json(); 

    //tmp.galeria = galeria.filter((x:any) => x.producto_id == tmp.id)

    return data;

}

export const getProductos = async () => {

    const response = await fetch(urlApi('/productos/obtener_productos.php')); 
         
    const { productos } = await response.json(); 
    
    /*let prod: ProductoI[] = []

    console.log(productos)

    for(let i in productos){
        let tmp =  productos[i]
        tmp.galeria = galeria.filter((x:any) => x.producto_id == tmp.id)
        prod.push(tmp)
    }*/

    return productos || [];

}